<template>
    <tiptap-vuetify :value="value" :extensions="extensions" v-on:input="updateValue"
    :placeholder="placeholder"
    :card-props="{ flat: true, tile: false, outlined: true}"/>
</template>
<script>
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History } from 'tiptap-vuetify'
export default {
    props: {
      value: {
        type: String
      },
      placeholder: String
    },

    components: { TiptapVuetify },
    data: () => ({
        extensions: [
            History,
            Blockquote,
            Link,
            Underline,
            Strike,
            Italic,
            ListItem,
            BulletList,
            OrderedList,
            [Heading, {
                options: {
                    levels: [2, 3]
                }
            }],
            Bold,
            Code,
            HorizontalRule,
            Paragraph,
            HardBreak,
            // [Image, {
            //   options: {
               
            //   }
            // }]
        ]
    }),

    methods: {
      updateValue(val) {
        this.$emit('input', val)
      }
    }
}
</script>